import axios from "axios"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, Col, Input, Row } from "reactstrap"
import Select from "react-select"

const ManualStatus = () => {
  const history = useHistory()

  const [statusList, setStatusList] = useState([])
  const [requestNo, setRequestNo] = useState("")
  const [requestNoError, setRequestNoError] = useState(null)
  const [currentStatus, setCurrentStatus] = useState("")
  const [newStatus, setNewStatus] = useState()

  // console.log("newStatus", newStatus)

  const formData = {
    PerToken: localStorage.getItem("token"),
    PerUserID: localStorage.getItem("id"),
    PerRoleID: localStorage.getItem("userRoleID"),
  }
  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API_URL + `api/BaladyDetails/Status.php`,
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let resData = Object.values(res.data)
        resData.splice(-1)
        resData = resData.map(item => ({ label: item.Name, value: item.BSID }))

        setStatusList(resData)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    if (`${requestNo}`.length > 9) {
      axios
        .post(
          process.env.REACT_APP_API_URL + `api/BaladyDetails/RefCheck.php`,
          {
            ...formData,
            RequestID: requestNo,
          }
        )
        .then(res => {
          if (
            res.data.error === true &&
            res.data.message === "Access denied!"
          ) {
            setAuth(true)
            setTimeout(() => {
              history.push("/logout")
              setTimeout(() => {
                history.push("/login")
              }, 1000)
            }, 4000)
          }

          // console.log("res.data", res.data)

          if (res.data.Status) {
            const status = statusList.filter(
              item => item.value === res.data.Status
            )[0]
            setCurrentStatus(status)
            setRequestNoError(null)
          } else {
            setCurrentStatus(null)
            setNewStatus(null)
            if (requestNo) {
              setRequestNoError("invalid")
            } else {
              setRequestNoError(null)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      setCurrentStatus(null)
      setNewStatus(null)
      if (requestNo) {
        setRequestNoError("invalid")
      } else {
        setRequestNoError(null)
      }
    }
  }, [requestNo])

  const applyStatusHandler = () => {
    axios
      .post(
        process.env.REACT_APP_API_URL + `api/BaladyDetails/NewHistory.php`,
        {
          ...formData,
          RequestID: requestNo,
          NewStatusID: newStatus.value,
        }
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        console.log("res.data", res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <div>
      <Row className="my-2">
        <h3>Add manual status</h3>
      </Row>
      <Row>
        <Col sm={4}>
          <label>Request No.</label>
          <Input
            type="number"
            value={requestNo}
            onChange={e => {
              setRequestNo(e.target.valueAsNumber)
            }}
          />
          <span className="error mx-2 d-flex justify-content-end">
            {requestNoError}
          </span>
        </Col>
        <Col sm={4}>
          <label>current Status</label>
          <Input
            type="text"
            readOnly
            value={currentStatus ? currentStatus.label : ""}
          />
        </Col>
        <Col sm={4}>
          <label>New Status</label>
          <Select
            // isMulti
            isClearable
            options={statusList}
            name="status"
            className="react-select-container"
            value={newStatus}
            isDisabled={!currentStatus}
            onChange={e => {
              // console.log(e)
              //   setFilteredValues({ ...filteredValues, users: e })
              setNewStatus(e)
            }}
            classNamePrefix="select"
            placeholder="New Status ..."
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} className="d-flex justify-content-end my-3">
          <Button
            disabled={!newStatus || !currentStatus}
            onClick={applyStatusHandler}
          >
            Apply
          </Button>
        </Col>
      </Row>
    </div>
  )
}

export default ManualStatus
